import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {addURI} from "@commons/utils/APIParams";
import {config} from "@commons/config.instance";

interface Image {
    image: string
}

export const fotoLavoratoreApi = createApi({
    reducerPath: 'fotoLavoratoreApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    tagTypes: ['fotoLavoratori'],
    endpoints: (builder) => ({

        getFotoLavoratore: builder.query<Image, { codiceFiscale: string, idAzienda: number }>({
            query: ({codiceFiscale, idAzienda}) => {
                return `/lavoratore/anagrafe/${codiceFiscale}-${idAzienda}/foto`;
            },
            transformResponse: addURI
        }),

        upload: builder.mutation<{ size: number }, { formData: FormData, codiceFiscale: string, idAzienda: number }>({
            query: ({formData, codiceFiscale, idAzienda}) => ({
                url: `/lavoratore/anagrafe/${codiceFiscale}-${idAzienda}/foto`,
                method: 'POST',
                body: formData,
            }),
        }),

    }),
})
export const {useLazyGetFotoLavoratoreQuery, useUploadMutation} = fotoLavoratoreApi;
// N.B. useLazyGetFotoLavoratoreQuery NON VIENE UTILIZZATA perchè si usa direttamente il tag IMG con il relativo indirizzo, vedi useFotoLavoratore